var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const BASE_ROUTER = 'api/integrations';
const BASE_ROUTER_MP_ATTEMPTS = 'api/payments/mp/attempts';
export const startMPOAuthFlow = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER}/mp/oauth/start`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const disconnectMP = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER}/mp/disconnect`, {}, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const importMPTerminal = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!data.storeId) {
                throw new Error('storeId is required');
            }
            if (!data.mp_pos_id) {
                throw new Error('mp_pos_id is required');
            }
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER}/mp/terminals/import`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const importAllMPTerminals = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            console.log('from washday-sdk importAllMPTerminals body', data);
            return yield this.axiosInstance.post(`${BASE_ROUTER}/mp/terminals/importAll`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const updateMPTerminalOperationMode = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER}/mp/terminals/updateOperationMode`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const createMPAttempt = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER_MP_ATTEMPTS}`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const cancelMPAttempt = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${BASE_ROUTER_MP_ATTEMPTS}/${data.attemptId}/cancel`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
